import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  const approved = user && (user.role === "admin" || user.status === "approved");

  const refresh = useCallback(async () => {
    if (!approved) { setItems([]); return; }
    try {
      const { data } = await api.get("/cart");
      setItems(data.items);
    } catch {}
  }, [approved]);

  useEffect(() => { refresh(); }, [refresh]);

  const setQty = async (productId, qty) => {
    await api.put("/cart/item", { product_id: productId, qty_boxes: qty });
    await refresh();
  };

  const clear = async () => {
    await api.delete("/cart");
    setItems([]);
  };

  const count = items.length;
  const total = items.reduce((s, it) => s + it.qty_boxes * (it.product.packing || 1) * (it.product.price_dozen || 0), 0);

  return (
    <CartContext.Provider value={{ items, setQty, clear, count, total, refresh }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
